module.exports = __webpack_public_path__ + "static/media/alertOutline.2d6568cf.svg";